export const COLOR_OPACITY_COMPETENCE = 0.3;
export const COLOR_OPACITY_AREA = 0.5;
export const COLOR_OPACITY_SUBAREA = 0.25;
